/*
 * THESE MATERIALS CONTAIN CONFIDENTIAL INFORMATION AND TRADE SECRETS 
 * OF BMC SOFTWARE, INC. YOU SHALL MAINTAIN THE MATERIALS AS
 * CONFIDENTIAL AND SHALL NOT DISCLOSE ITS CONTENTS TO ANY THIRD
 * PARTY EXCEPT AS MAY BE REQUIRED BY LAW OR REGULATION. USE, 
 * DISCLOSURE, OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR 
 * EXPRESS WRITTEN PERMISSION OF BMC SOFTWARE, INC. 
 *
 * ALL BMC SOFTWARE PRODUCTS LISTED WITHIN THE MATERIALS ARE TRADEMARKS
 * OF BMC SOFTWARE, INC. ALL OTHER COMPANY PRODUCT NAMES ARE
 * TRADEMARKS OF THEIR RESPECTIVE OWNERS. 
 * 
 * © Copyright 2020 BMC Software, Inc. 
 * 
 */
$(function() {
    'use strict'
    var lastSelectedRow = 0;
    var loggingTable = null;
    var initialTotalTestLogLevel = null;
    var initialJettyLogLevel = null;
    const totalTestName = "Topaz for Total Test";
    const jettyName = "Jetty Server";
    var that = this;
    var interval = null;
    var pingTimeout = null;
    
	var handleApplyClicked = function() {
		let currentTotalTestLogLevel = getTotalTestLogLevel();
		let currentJettyLogLevel = getJettyLogLevel();
			
		if ((currentTotalTestLogLevel != null && initialTotalTestLogLevel != null && currentTotalTestLogLevel != initialTotalTestLogLevel)
				|| (currentJettyLogLevel != null && initialJettyLogLevel != null && currentJettyLogLevel != initialJettyLogLevel))
		{
			showRestartDialog();
		} else {
			applySettings(false);
		}
	};
	
	var applySettings = function(restart) {
		$.displayLoadingIndicator(savingData);
	    var appLoggingLevelData = [];
	    
		$('.logging-level-select option:selected').each(function(index) {
			var name = $(this).closest('tr').find('td:first-child a').text().trim();
			var loglevel = $(this).val();
			var logconfig = {
			    name : name,
				loglevel : loglevel
			};
						
			appLoggingLevelData.push({logconfig : logconfig});        	
		});
		
		var str = JSON.stringify(appLoggingLevelData);
		var callback = handleSaveResult;
		
		if (restart) {
			callback = handleRestart;
		}

	    $.ajax({
	        type: 'POST',
            url : 'settings/saveLoggingConfig',
            data : {
            	loggingarray : JSON.stringify(appLoggingLevelData)
            },
            dataType: 'json',
            async : true,
            cache : false,
            success: callback,
            error: handleSaveResult
        });    
	};
	
	var handleRowSelection = function(event) {
	    var target = event.target;
        var tableCell = event.currentTarget;
        var tableRow = $(tableCell).parent();
        var tableObject = $(tableCell).parents('table');
        
        if (!!target && target.nodeName.toLowerCase() === 'td' && !!tableCell && !!tableObject) {
            if (!event.ctrlKey && !event.shiftKey) {
                tableObject.find('td.cell-selected').removeClass('cell-selected');
                tableRow.find('td').toggleClass('cell-selected');
                lastSelectedRow = $(this).parent().index() + 1;
            } else if (event.ctrlKey && !event.shiftKey) {
                tableRow.find('td').toggleClass('cell-selected');
                
                if (tableObject.find('td.cell-selected').length > 0) {
                    lastSelectedRow = $(tableCell).parent().index()  + 1;
                } else {
                    lastSelectedRow = 0;
                }
            } else if (!event.ctrlKey && event.shiftKey) {
                if (lastSelectedRow === 0) {
                    tableRow.find('td').toggleClass('cell-selected');
                    lastSelectedRow = $(tableCell).parent().index()  + 1;
                } else {
                    tableObject.find('td.cell-selected').removeClass('cell-selected');
                    var rows = $(tableObject).find('> tbody > tr');
                    var selectedRow = $(tableCell).parent().index()  + 1;
                    var firstRow = Math.min(selectedRow, lastSelectedRow);
                    var lastRow = Math.max(selectedRow, lastSelectedRow);
                    
                    for (var index = firstRow; index <= lastRow; index++) {
                        $(rows[index - 1]).find('td').toggleClass('cell-selected');
                    }
                }
            }
        }

        if ($('.cell-selected').length > 0) {
            $('#downloadLogFiles').removeAttr('disabled');
        } else {
            $('#downloadLogFiles').attr('disabled', 'disabled');
        }
    };
    
	// Handle the result from the save request
	var handleSaveResult = function(data) {
		$.removeLoadingIndicator();
		
		if (data.success) {
			initialize();
			$.showSuccessStatus(saveSuccessful);
		} else {
			$.showErrorStatus(data.responseJSON.message);
		}
	};
	
	var handleRestart = function(data) {
		$.removeLoadingIndicator();
		
		if (data.success) {
			restart();
			initialize();
		} else {
			$.showErrorStatus(data.responseJSON.message);
		}
	};
	
	var sortLoggingOptions = function(a,b) {
	  if ((a.app).toLowerCase() < (b.app).toLowerCase()) {
		    return -1;
	  }
	  
	  if ((a.app).toLowerCase() > (b.app).toLowerCase()) {
		    return 1;
	  }
	  
	  return 0;
	};

	var initializeLoggingTable = function(data) {
	    if (loggingTable === null) {
            var headers = [{
               title : componentNameColumnText 
            }, {
               title : logFilenameColumnText 
            }, {
               title : lastModifiedColumnText 
            }, {
               title : loggingLevelColumnText 
            }];
            
            var loggingTableOptions = {
                columns : [{
                    data : 'displayName',
                    render : function(value, type, rowData) {
                        if (type === 'display') {
                        	
                        	if (rowData.displayName === "Jetty Server") {
                        		return '<a href="jsp/settings/logFileViewer.jsp?app=' + value + '&file=' + rowData.logFile + '" '+
                        		(rowData.loglevel === 'debug' ? ' class="disabled"' : '') + '>' + value + '</a>' +
                        		(rowData.loglevel === 'debug' ? ' <i class="jetty-desc-toggle fa fa-question-circle-o"></i>' + jettyDebugMessage : ''); 
                        	}
                        	
                            return '<a href="jsp/settings/logFileViewer.jsp?app=' + value + '&file=' + rowData.logFile + '">' + value + '</a>';
                        }
                        
                        return value;
                    },
                    defaultContent : ''
                }, {
                    data : 'logFile',
                    defaultContent : ''
                }, {
                    data : 'lastModified',
                    className : 'right-align-cell',
                    defaultContent : ''
                }, {
                    data : 'loglevel',
                    render : function(value, type, rowData) {
                    	// Current configuration only allows INFO and DEBUG jetty logs (until migrated to SLF4J)
                        if (type === 'display' && rowData.displayName === "Jetty Server") 
                        {
                            return '<select class="logging-level-select"' + (!!rowData.infoOnly ? ' disabled="disabled"' : '') + '>' +
                            '<option value="info"' + (value === 'info' ? ' selected' : '') + '>' + infoText + '</option>' +
                            '<option value="debug"' + (value === 'debug' ? ' selected' : '') + '>' + debugText + '</option>' +
                            '</select>';
                        }
                        else if (type === 'display') 
                        {
                            return '<select class="logging-level-select"' + (!!rowData.infoOnly ? ' disabled="disabled"' : '') + '>' + 
                            '<option value="error"' + (value === 'error' ? ' selected' : '') + '>' + errorText + '</option>' +
                            '<option value="warn"' + (value === 'warn' ? ' selected' : '') + '>' + warnText + '</option>' +
                            '<option value="info"' + (value === 'info' ? ' selected' : '') + '>' + infoText + '</option>' +
                            '<option value="debug"' + (value === 'debug' ? ' selected' : '') + '>' + debugText + '</option>' +
                            '<option value="trace"' + (value === 'trace' ? ' selected' : '') + '>' + traceText + '</option>' +
                            '</select>';
                        }
                        
                        return value;
                        
                    },
                    className : 'select-cell',
                    defaultContent : ''
                }],
                order : [[1, 'asc']],
                data : data
            };
            
            loggingTable = new SimpleTableComponent('loggingTable', '#loggingTableContainer', headers, {includePagination : false, includeFilter : false});
            loggingTable.createTable(loggingTableOptions);
            $('#loggingTableContainer').on('click', 'tbody > tr > td:not(:last-child)', handleRowSelection);
	    } else {
	        var table = loggingTable.getTable();
	        table.clear();
	        table.rows.add(data);
	        table.draw();	        
	    }
	};
	
	var initialize = function() {
	    initializeLoggingTable([]);
	    
        $.getJSON('settings/getLoggingConfig', {nocache : new Date().getTime()}).done(function(response) {
            if (!!response && !!response.loggingarray) 
            {
                initializeLoggingTable(JSON.parse(response.loggingarray));
        		initialTotalTestLogLevel = getTotalTestLogLevel();
        		initialJettyLogLevel = getJettyLogLevel();
            }
        }).always(function() {
            $(window).trigger('loggingLoaded');
        });         
	};
	
	var showRestartDialog = function() {
        $('#restartDialog').dialog({
            title: restartTitle,
            width: 500,
            modal: true,
            draggable : false,
            resizable : false,
            buttons : {
                "OK" : {
                    text : okButtonText,
                    'class' : 'ok-button',
                    click : function() {
                        $.animateCloseDialog('#restartDialog', '#applyLogging');
                        applySettings(true);
                        $(this).dialog('close');
                    }
                },
                "Cancel" : {
                    text : cancelButtonText,
                    click : function() {
                        $.animateCloseDialog('#restartDialog', '#applyLogging');
                        $(this).dialog('close');
                    }
                }
            },
            open: function(event, ui) {
                if (location.protocol === 'https:' && !$('#httpsCheckbox').is(':checked')) {
                    $('#restartMessage').append('<br><br>' + restartHttpsText);
                }
                
                $(this).dialog('option', 'position', {my: 'center', at: 'center', of: window});
                $.animateOpenDialog('#restartDialog', '#applyLogging');
            }
        });
    };
    
    var restart = function() {
        $.when(
            $.getJSON('maintenance/restart', {nocache: new Date().getTime()})
        ).done(function(response) {
            if (response.success == false) {
                $.showErrorStatus(com.compuware.ces.restartFailed);
            } else {
                var protocol = 'https';
                var port = $('#httpsPort').val();
                
                if ((location.protocol === 'http:' && $('#httpCheckbox').is(':checked')) || !$('#httpsCheckbox').is(':checked'))  {
                    protocol = 'http';
                    port = $('#httpPort').val();
                }
                
                $.displayLoadingIndicator(restartingText);
                $('.animated-logo-wrapper').addClass('restart');
                var timeout = getTestingTimeout() || 600;
                pollServer(timeout, protocol + '://' + location.hostname + ':' + port, protocol);
            }
        });
    };
    
    var getTestingTimeout = function() {
        var queryString = location.search
        
        var matches = /\?.*timeout=(\d*)&?/i.exec(queryString);
        
        if (matches) {
            return matches[1];
        }
    };
    
    var pollServer = function(timeout, serverPrefix, protocol) {
        var pollPromise = null;
        var down = false;
        var gracePeriod = false;
        var progressInterval;
        
        // ping the server every 5 seconds
        var pingInterval = setInterval(function() {
            pollPromise = $.ajax({
                type: 'GET',
                url : serverPrefix + '/totaltest',
                cache : false,
                nocache: new Date().getTime()
            })
            
            pollPromise.then(function() {
                // if the request went down previously, and is now back up, we're good
                if (down == true) {  
                    $.debugLog('request succeeded after restart');
                    clearInterval(pingInterval);
                    clearTimeout(that.pingTimeout);
                    $.removeLoadingIndicator();
                    $.showSuccessStatus(saveSuccessful);
                }               
            }, 
            // failed ping callback
            function(err) {  
                $.debugLog('ping failed...');
                // when ping fails, set the down status
                if (!down) {
                    $.debugLog('service has stopped responding...');
                    down = true;
                }
                
                if (err.status == 404 && down && !gracePeriod) {
                    gracePeriod = true;
                    clearTimeout(that.pingTimeout);
                    setPingTimeout(pingInterval, timeout, serverPrefix, protocol);
                    $.debugLog('service has responded with error, extending timeout for OSGi grace period...');
                }
            });
        }, 5000);
        
        setPingTimeout(pingInterval, timeout, serverPrefix, protocol);
    };
    
    var setPingTimeout = function(pingInterval, timeout, serverPrefix, protocol) {
        // after timeout minutes, we give up pinging
        that.pingTimeout = setTimeout(function() {
            $.debugLog('timeout reached, service has not responded');
            clearInterval(pingInterval);
            clearTimeout(that.pingTimeout);
            $.removeLoadingIndicator();
            $('.animated-logo-wrapper').removeClass('restart');
            
            if (location.protocol === 'https:' && protocol === 'http') {
                location.href = serverPrefix + location.pathname + location.search;
            } else {
                $.showMessageDialog({
                    title: restartError, 
                    message: restartTimeoutText
                });
            }
        }, 1000 * timeout);
    };
    
    function getTotalTestLogLevel() {
	    let logLevel = null;
	    
		$('.logging-level-select option:selected').each(function(index) {
			var name = $(this).closest('tr').find('td:first-child').text().trim();
			
			if (name == totalTestName)
				logLevel = $(this).val();		     	
		});
		
		return logLevel;
    }
    
    var closeTooltipHandler = function(event){
        event.stopPropagation();
        $('.jetty-desc-toggle.open').removeClass('open');
        return true;
    }
    
    var openTooltipHandler = function (event) {
        event.stopPropagation();
        var openToggle = $('.jetty-desc-toggle.open');
        
       	closeTooltipHandler(event);

        if (openToggle[0] !== $(this)[0]) {
            $(this).addClass('open');
            $('body').on('click', closeTooltipHandler);
        }
        
        return true;
    }
    
    function getJettyLogLevel() {
    	let logLevel = null;
    	
		$('.logging-level-select option:selected').each(function(index) {
			var name = $(this).closest('tr').find('td:first-child a').text().trim();
			
			if (name == jettyName)
				logLevel = $(this).val();		     	
		});
		
		return logLevel;
    }

	$(document).ready(function() {
		initialize();
		$('#applyLogging').click(handleApplyClicked);
		
		$('#loggingTableTable').on('click', '.jetty-desc-toggle', openTooltipHandler );
		
		$('#downloadLogFiles').click(function() {
		    var selectedFiles = [];
		    var logFiles = {};
		    
		    $('.cell-selected:nth-child(2)').each(function(index) {
		        logFiles[$(this).text().trim()] = true;
		    })
		    
		    for (var key in logFiles) {
		        selectedFiles.push(key);
		    }
		    
		    $.displayLoadingIndicator(downloadFilesText);
		    
		    var url = $('base').attr('href') + 'ws/logs';
		    
		    $.when(downloadZip(url, 'logFiles.zip', JSON.stringify({logFilesRequested : selectedFiles}), 'POST'))
				.fail(function(status, statusText) {
					$.showErrorStatus(downloadFailText + ' ' + status + ' ' + statusText);
				}).always(function() {
					$.removeLoadingIndicator();
				});
		});
	});
		
});